const FeedbackListFilter = (feedbackList, filterString) => {
  if (filterString) {
    filterString = filterString.toUpperCase();
    feedbackList = feedbackList.filter(item =>
      (item.userName && item.userName.toUpperCase().includes(filterString)) ||
        (item.feedback && item.feedback.toUpperCase().includes(filterString)) ||
        (item.feedbackUserName &&
          item.feedbackUserName.toUpperCase().includes(filterString)));
  }
  return feedbackList;
};

export default FeedbackListFilter;



// WEBPACK FOOTER //
// ./src/utils/filtering/FeedbackListFilter.js